import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { formatDateTime } from "../utils/dateRangeUtils";

function formatPeople(people) {
  if (!people || people.length === 0) {
    return "None listed";
  }

  return people
    .map((person) => person.name || person.email)
    .filter(Boolean)
    .join(", ");
}

function getJoinUrl(assignment) {
  return assignment?.joinUrl || assignment?.onlineMeetingUrl || null;
}

export function ScheduleClassDialog({ assignment, open, onClose }) {
  if (!assignment) {
    return null;
  }

  const students = assignment.students || [];
  const coaches = assignment.coaches || [];
  const teamLabel = assignment.teamName || assignment.teamId || "Not resolved";
  const joinUrl = getJoinUrl(assignment);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
          <Box>
            <Typography variant="h6">
              {teamLabel || assignment.title || "Scheduled class"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {formatDateTime(assignment.start)} - {formatDateTime(assignment.end)}
            </Typography>
          </Box>
          <Chip
            label={assignment.online ? "Online" : "In person"}
            size="small"
            color={assignment.online ? "primary" : "default"}
          />
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Stack gap={2}>
          <Box>
            <Typography variant="subtitle2">Class title</Typography>
            <Typography variant="body2">{assignment.title || "Scheduled class"}</Typography>
          </Box>

          <Divider />

          <Box>
            <Typography variant="subtitle2">Team</Typography>
            <Typography variant="body2">{teamLabel}</Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2">Students</Typography>
            <Typography variant="body2">{formatPeople(students)}</Typography>
            <Typography variant="caption" color="text.secondary">
              {students.length === 1 ? "1 student listed" : `${students.length} students listed`}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2">Coach(es)</Typography>
            <Typography variant="body2">{formatPeople(coaches)}</Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2">Location</Typography>
            <Typography variant="body2">
              {assignment.location || (assignment.online ? "Online meeting" : "In person")}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        <Button onClick={onClose}>Close</Button>
        {joinUrl && (
          <Button
            variant="contained"
            href={joinUrl}
            target="_blank"
            rel="noreferrer"
            endIcon={<OpenInNewIcon />}
          >
            Join Teams meeting
          </Button>
        )}
        {assignment.webLink && (
          <Button
            variant="outlined"
            href={assignment.webLink}
            target="_blank"
            rel="noreferrer"
            endIcon={<OpenInNewIcon />}
          >
            Open calendar event
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
